import {Component, ChangeDetectionStrategy, Input, OnChanges, SimpleChanges} from "@angular/core";
import {CompositeFilterDescriptor} from "@progress/kendo-data-query";
import {BaseFilterCellComponent, FilterService} from "@progress/kendo-angular-grid";

@Component({
	selector: 'cp-grid-dropdownlist-filter-cell',
	templateUrl: './grid.dropdownlist.filter.cell.html',
	styleUrls: ['./grid.dropdownlist.filter.cell.scss'],
	changeDetection:ChangeDetectionStrategy.OnPush
})
export class GridDropDownListFilterCellComponent extends BaseFilterCellComponent implements OnChanges {

	@Input() data: any[];
	@Input() field: string;
	@Input() filter: CompositeFilterDescriptor;
	@Input() translateSuffix: string;

	public dropDownData: any[];

	public get selectedValue(): any {
		let filter = this.filterByField(this.field);
		return filter ? filter.value : null;
	}

	constructor(filterService: FilterService) {
		super(filterService);
	}

	public onClearFilterClick() {
		this.applyFilter(this.removeFilter(this.field));
	}

	public onDropdownListFilterChange(value: any): void {
		this.applyFilter(!value || value[this.field] === '' ? this.removeFilter(this.field) :
			this.updateFilter({
				field: this.field,
				operator: "eq",
				value: value
			})
		);
	}

	public ngOnChanges(changes: SimpleChanges) {
		if (changes['data']) {
			this.dropDownData = undefined;
		}
	}
	public onDropDownOpen(){
		//Create the data ones when the dropDown opens.
		if (this.data && !this.dropDownData) {
			this.createDropDownData();
		}
	}

	public createDropDownData(){
		//Create distinct list sorted by abc.
		this.dropDownData = [];
		this.data.map(row => row[this.field]).forEach((x) =>{
			if (this.dropDownData.findIndex((y)=> y === x) < 0){
				this.dropDownData.push(x);
			}
		});

		this.dropDownData = this.dropDownData.sort((s1, s2) => (s1 > s2) ? 1 : -1);
	}
}

